module.exports = __webpack_public_path__ + "assets/img/00082.2417dbf0.png";